import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ButtonComponent from "./buttons/ButtonComponent";

const UnauthenticatedUser = () => {
  return (
    <Box margin="20px">
      <Typography sx={{ color: "red", fontSize: "18px", fontWeight: "600" }}>
        Access Restricted
      </Typography>
      <Typography>Click on button to access Cellma Flex.</Typography>
      <ButtonComponent
        buttontitle="Back to home page"
        component={RouterLink}
        to="/"
        sx={{ width: "250px", mt: "25px", borderRadius: "20px", backgroundColor: "#0d47a1" }}
        label="Back to home page"
        size="medium"
      />
    </Box>
  );
};

export default UnauthenticatedUser;
